<template>
    <div class="render-post hide-scrollbar render-post-pinterest">

        <div class="post-content">
       
            <div class="post-medias media" :class="{empty : notFile && !snippet.link}">
                <div class="media" v-for="media in medias.filter(m => ['image','video'].includes(m.type2) && m.type !== 'image/gif').slice(0,1)" :key="media.id" :style="media.type2 == 'image' ? `background: url('${media.url}');` : 'background-color: #f7f7f7;'">
                    <img v-if="media.type2 == 'image'" class="source" :src="media.url" alt="">
                    <video v-else-if="media.type2 == 'video'" class="source" :src="media.url" alt="" muted playsinline autoplay loop preload="metadata" onloadedmetadata="this.muted = true"></video>
                </div>
    
                <SnippetNetwork v-if="notFile && snippet.link" :link="snippet.link"/>
                <div class="domaine-redirection" v-if="snippet.link"><i class="fa-solid fa-arrow-up-right"></i><p>{{ getHostname(snippet.link) }}</p></div>
              
             
            </div>
           
            

            <div class="post-title">
                <p v-html="titleTranslateMentionAndHastag || 'Titre'"></p>
            </div>
            <div class="post-text">
                <p v-html="textTranslateMentionAndHastag || 'Description'"></p>
            </div>
            <div class="post-page">
                <div class="img-pages">

                    <template v-for="(picturePage,index) in picturePages.slice(0,picturePages.length == 4 ? 4 : 3)">
                        <Tooltip :active="picturePage.iconEdited" :key="index" :text="'Voir les modifications apportées'" position="right" :classCustom="`page ${picturePage.iconEdited ? 'iconEdited' : ''}`" @click="()=>{$emit('clickPage', picturePage.id)}">
                            <img :src="picturePage && picturePage.avatar ? picturePage.avatar : 'img/avatar.jpg'" alt="">
                        </Tooltip>
                    </template>
          
                    <div class="page count" v-if="picturePages.length > 4">
                        +{{ picturePages.length - 3 }}
                    </div>
                </div>
                <p class="name" v-if="picturePages.length == 1">{{ pageName }}</p>
            </div>
           
           
            
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from '../SnippetNetwork.vue'
    import Tooltip from '../../tooltip/tooltipInit.vue'

    export default {
        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip
        },

        props: {
            picturePages: {
                type: Array,
                default: ()=>[] 
            },
            pageName : {
                type: String,
                default: ''
            },
            datePost: {
                default: 1315349759920 
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },
            title : {
                type: String,
                default: 'Titre'
            },
            text : {
                type: String,
                default: 'Description'
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : "",
                    title: "",
                    description: "",
                    domaine:"",
                    imageUrl:""
                })
            },

            mentions: {
                type: Object,
                default: ()=>({})
            }
           
        },

        methods: {
            getHostname(url) {
                return (new URL(url)).hostname.replace("www.", "");
            },
        },

        computed: {
            dateFormatPost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            notFile(){
                return !this.medias.length || !this.medias.filter(m => ['image','video'].includes(m.type2)).length
            },


            titleTranslateMentionAndHastag() {
                //return this.text
                return this.title.replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.pinterest ? `<span class="mention">@${mention.mention.pinterest.id || mention.mention.pinterest.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },

            textTranslateMentionAndHastag() {
                //return this.text
                return this.text.replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.pinterest ? `<span class="mention">@${mention.mention.pinterest.id || mention.mention.pinterest.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            }
        },
    }
</script>
